import React from 'react'
import Paper from '@material-ui/core/Paper'
import InputBase from '@material-ui/core/InputBase'
import Typography from '@material-ui/core/Typography'
import MenuItem from '@material-ui/core/MenuItem'

import classes from './AutoCompleteTextfield.module.scss'
export default function AutoCompleteTextfield(props) {
  const { label = '', required, readOnly, suggestions = [], onChange, error, constainerStyle, onClick, ...other } = props
  const { value = '', name, id } = props

  const [focus, setFocus] = React.useState()
  const [_error, setError] = React.useState()

  React.useEffect(() => {
    setError()
    if (typeof value === 'string') {
      if (!value.trim()) setError(error)
    }
  }, [error, value])

  const handleOnChange = e => {
    setError()
    if (typeof onChange === 'function') onChange(e.target.value)
  }

  const handleItemClick = index => {
    setFocus(false)
    setError()
    if (typeof onChange === 'function') onChange(suggestions[index], true, index)
  }

  const handleBlur = e => {
    if (!e.currentTarget.contains(e.relatedTarget)) setFocus(false)
  }

  return (
    <div className={classes.root} style={constainerStyle}>
      {label && (
        <Typography variant='subtitle2' className={classes.label}>
          {label}
          {!readOnly && required ? ' *' : ''}
        </Typography>
      )}

      <div className={classes.wrapper}>
        {readOnly ? (
          //  Read Only Value
          <Typography id={props.id} variant='subtitle2' className={`${classes.label} ${classes['read-only-value']}`}>
            {value}
          </Typography>
        ) : (
          <React.Fragment>
            <Paper
              className={`${classes['autocomplete-field']} ${_error ? classes['has-error'] : focus && classes.focus
                } box-shadow-field`}
              onBlur={handleBlur}
            >
              <InputBase
                className={classes.input}
                id={id}
                name={name}
                onChange={e => {
                  handleOnChange(e)
                }}
                {...other}
                autoComplete='off'
                onClick={onClick}
                onFocus={() => setFocus(true)}
              />
              {focus && (
                <Paper square style={{ height: '100%', maxHeight: '150px', overflowX: 'hidden' }}>
                  {suggestions.map((suggestion, index) => (
                    <MenuItem
                      style={{ fontSize: '14px' }}
                      onClick={() => {
                        setFocus(true)
                        handleItemClick(index)
                      }}
                    >
                      {suggestion}
                    </MenuItem>
                  ))}
                </Paper>
              )}
            </Paper>
            {_error && <span className={classes.error}>{_error}</span>}
          </React.Fragment>
        )}
      </div>
    </div>
  )
}
